import React from "react";
import { Eye } from "lucide-react";

export default function SubscriptionsTable({ mealPlans = [], onViewPlanClick, isScrollable = false }) {
  // Helper to format status badges
  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
      case "1":
        return "bg-success-bg text-success border-success/20";
      case "paused":
      case "2":
        return "bg-warning-bg text-warning border-warning/20";
      case "cancelled":
      case "4":
        return "bg-brand-red-light text-brand-red border-brand-red/10";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  return (
    <div className="w-full">
      {/* RESPONSIVE TABLE VIEW */}
      <div
        className={`w-full overflow-x-auto bg-white rounded-xl border border-border-primary shadow-xs scrollbar-thin ${isScrollable ? "max-h-[420px] overflow-y-auto" : ""
          }`}
      >
        <table className="w-full text-left border-separate border-spacing-0 min-w-[700px] md:min-w-0">
          <thead>
            <tr className="bg-bg-secondary text-[11px] uppercase tracking-wider font-bold text-text-secondary sticky top-0 z-20">
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Plan ID</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Meal Name</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Type</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Billing & Slot</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Consumed</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary">Status</th>
              <th className="py-4 px-6 bg-bg-secondary border-b border-border-primary text-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-primary text-sm bg-white">
            {mealPlans.map((plan) => {
              const isLunch = plan.meal_type?.toLowerCase() === "lunch";
              const typeBadgeColor = isLunch
                ? "bg-[#FCE8E6] text-brand-red border border-brand-red/10"
                : "bg-[#EBE8FC] text-[#6366F1] border border-[#6366F1]/10";

              return (
                <tr
                  key={plan.meal_plan_id}
                  onClick={() => onViewPlanClick(plan)}
                  className="hover:bg-bg-secondary/40 transition-colors cursor-pointer group"
                >
                  <td className="py-4 px-6 font-mono font-semibold text-text-primary border-b border-border-primary/60">
                    #{plan.meal_plan_unique_id}
                  </td>
                  <td className="py-4 px-6 font-bold text-text-primary border-b border-border-primary/60">
                    {plan.meal_name}
                  </td>
                  <td className="py-4 px-6 border-b border-border-primary/60">
                    <span className={`inline-flex px-2 py-1 rounded text-[10px] font-black uppercase tracking-wider ${typeBadgeColor}`}>
                      {plan.meal_type}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-text-secondary border-b border-border-primary/60">
                    <div className="flex flex-col text-xs">
                      <span className="font-semibold text-text-primary">{plan.billing_type} ({plan.delivery_preference})</span>
                      <span className="text-[10px] text-text-muted mt-0.5">{plan.time_slot}</span>
                    </div>
                  </td>
                  <td className="py-4 px-6 font-semibold text-text-primary font-mono border-b border-border-primary/60">
                    <span>{plan.meals_consumed} / {plan.number_of_deliveries || "Ongoing"}</span>
                  </td>
                  <td className="py-4 px-6 border-b border-border-primary/60">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold border ${getStatusBadge(plan.status_label || (plan.status === 1 ? 'active' : ''))}`}>
                      {plan.status_label || (plan.status === 1 ? 'active' : 'inactive')}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-center border-b border-border-primary/60 font-medium">
                    <div className="flex justify-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onViewPlanClick(plan);
                        }}
                        className="p-1.5 text-brand-red hover:text-brand-red-hover hover:bg-brand-red-light/20 rounded-lg transition-colors cursor-pointer"
                        title="View Plan Details"
                      >
                        <Eye className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
